module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Light.2614194.ttf";